import { render, staticRenderFns } from "./create_kimi.vue?vue&type=template&id=40a2d037&scoped=true"
import script from "./create_kimi.vue?vue&type=script&lang=js"
export * from "./create_kimi.vue?vue&type=script&lang=js"
import style0 from "./create_kimi.vue?vue&type=style&index=0&id=40a2d037&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2d037",
  null
  
)

export default component.exports